<template>
  <div class="dashboard">
    <dashboard-charts />
    <dashboard-info-block />
      <div class="row row-equal">
        <div class="flex xl8 xs12">
          <div class="xl12 xs12 sm12">
            <dashboard-tabs/>
          </div>
          <br>
          <div class="xl12 xs12 sm12">
            <dashboard-table/>
          </div>
        </div>            
        <div class="flex xl4 xs12">
          <dashboard-kins/>
        </div>
      </div>
  </div>
</template>

<script>
import DashboardCharts from './DashboardCharts'
import DashboardInfoBlock from './DashboardInfoBlock'
import DashboardTable from './DashboardTable'
import DashboardTabs from './DashboardTabs'
import DashboardKins from './DashboardKins'

export default {
  name: 'dashboard',
  components: {
    DashboardCharts,
    DashboardInfoBlock,
    DashboardTable,
    DashboardTabs,
    DashboardKins,
  },
  data () {
    return {
      userData: {},
    }
  },
  created () {
    this.userData = JSON.parse(localStorage.getItem('LoggedUser'))
  },
  methods: {

  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }

  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
